export default "__VITE_ASSET__rqySSyif__"